import { Component, inject, Input } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { BodyLarge } from '../../components/typography/body-large/body-large'
import { Link } from '../../components/link/link'
import { SharedContent } from '../../services/shared-content/shared-content'

@Component({
	selector: 'app-cta-banner-gradient-bg',
	imports: [ButtonModule, BodyLarge, Link],
	templateUrl: './cta-banner-gradient-bg.html',
	styleUrl: './cta-banner-gradient-bg.css',
})
export class CtaBannerGradientBg {
	@Input() content!: ComponentWithCopy

	private sharedContentService = inject(SharedContent)

	ctaButtonClicked(path: string): void {
		this.sharedContentService.navigateTo(path)
	}
}
